<template>
    <div class="sm:max-w-4xl mx-auto">
        <resource-index title="Заказы" :endpoint="endpoint">
            <template v-slot:table-header>
                <tr class="border-b">
                    <th class="text-left p-3 px-5" scope="col">Тип</th>
                    <th class="text-left p-3 px-5" scope="col">Товар</th>
                    <th class="text-left p-3 px-5" scope="col">Сумма</th>
                    <th class="text-left p-3 px-5" scope="col"></th>
                </tr>
            </template>

            <template v-slot:row="slotProps">
                <td class="p-3 px-5">
                    <span class="badge whitespace-no-wrap badge-pink" v-if="slotProps.entry.rental">Аренда</span>
                    <span class="badge whitespace-no-wrap badge-info" v-else>Продажа</span>
                </td>

                <td class="p-3 px-5">{{ slotProps.entry.product.name }}</td>

                <td class="p-3 px-5">
                    <span class="badge whitespace-no-wrap badge-success">{{ slotProps.entry.amount }}₽</span>
                </td>

                <td class="p-3 px-5">
                    <router-link
                        v-if="slotProps.entry.rental"
                        :to="{
                        name: 'admin.billing.rentals.edit',
                        params: {
                            id: slotProps.entry.rental.id
                        }
                    }"
                        class="btn btn-info"
                    >Открыть</router-link>

                    <router-link
                        v-if="! slotProps.entry.rental"
                        :to="{
                        name: 'admin.billing.orders.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                        class="btn btn-info"
                    >Открыть</router-link>
                </td>
            </template>
        </resource-index>
    </div>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    },

    props: {
        customerId: [String, Number]
    },

    data() {
        return {
            endpoint: `admin/customers/${this.customerId}/orders`
        };
    }
};
</script>